import { render } from "./HomeConceptPage.vue?vue&type=template&id=b4b1fb4e&scoped=true"
import script from "./HomeConceptPage.vue?vue&type=script&lang=js"
export * from "./HomeConceptPage.vue?vue&type=script&lang=js"

import "./HomeConceptPage.vue?vue&type=style&index=0&id=b4b1fb4e&scoped=true&lang=css"
import "../assets/css/home-story.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4b1fb4e"]])

export default __exports__